 <template>
 <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Producten" @hidden="$emit('close')">
    <div class="block block-bordered">
        <div class="block-header block-header-default">
            <h3 class="block-title">Producten op gescande locatie</h3>
        </div>
        <div class="block-content p-0">
            <table ref="table" class="table table-borderless table-striped table-hover">
            <thead>
                <tr>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in products" :key="product.id">
                    <td scope="row" class="border-1" style="width: 500px;">
                        <div class="p-2">
                        <img :src="product.image_urls[0]" alt="" width="70" class="img-fluid rounded shadow-sm">
                        <div class="ml-3 d-inline-block align-middle">
                            <h5 class="mb-0"> <a href="#" class="text-dark d-inline-block align-middle" @click="select(product)">{{product.name}}</a></h5>
                        </div>
                        </div>
                    </td> 
                </tr>
            </tbody>
            </table>
        </div>
    </div>
    <product-detail-modal v-if="detailModalProductId" :key="detailModalProductId" :product-id="detailModalProductId" @close="detailModalProductId = null"></product-detail-modal>
  </b-modal>
</template>

<script>
import ProductDetailModal from './ProductDetailModal'

export default {
  components: {
    ProductDetailModal
  },
  props: {
    products: Array
  },
  data () {
    return {
      detailModalProductId: null
    }
  },
  methods: {
    select (product) {
      this.$emit('select', product)
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}


</style>



// WEBPACK FOOTER //
// LocationScannedModal.vue?698d64e5